import moment from 'moment-timezone'
import { pickerDate, dateKey, createRangeLoader } from './reportRange'

// Shared Vue 2 lifecycle for the read-only report tables. Each route owns its
// dates and request; a previous route cannot replace the next route's rows.
export default function saleReportPage ({ action, field, singleDate = false, daysAgo = 0, reportDayOffset = 0 }) {
  return {
    data () {
      return { datestart: pickerDate(daysAgo), dateend: pickerDate(daysAgo), reportLoading: true, reportError: '' }
    },
    computed: {
      usersData () { return this.reportLoading || this.reportError ? [] : this.$store.state.report[field] }
    },
    watch: {
      datestart () { this.calculate() },
      dateend () { this.calculate() }
    },
    methods: {
      reportDates () {
        const start = dateKey(this.datestart)
        if (!singleDate) return [this.datestart, this.dateend]
        const date = start && moment(start, 'YYYY-MM-DD', true).add(reportDayOffset, 'days').format('YYYY-MM-DD')
        return [date, date]
      },
      calculate () { if (this._reportLoader) this._reportLoader.schedule(...this.reportDates()) },
      retryReport () { return this._reportLoader.schedule(...this.reportDates(), true) }
    },
    created () {
      this._reportLoader = createRangeLoader({
        invalidate: () => this.$store.dispatch('report/invalidateCurrentReport'),
        loading: value => { this.reportLoading = value },
        error: value => { this.reportError = value },
        load: range => this.$store.dispatch('report/' + action, {datestart: range.start, dateend: range.end})
      })
      this.retryReport()
    },
    beforeDestroy () { this._reportLoader.stop() }
  }
}
